export default __webpack_public_path__ + "static/media/LSP.e1f3d362.png";